import "../App.css";

import Hero from "../components/hero/Hero";
import Imgbanner from "../components/Banner/imgbanner";
import ProgramCard from "../components/programCard/programCard";
import Gallery from "../components/Gallery/Gallery";
import { GrLocation } from "react-icons/gr";
import { MdOutlineCalendarToday } from "react-icons/md";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";
import { HiOutlineBookOpen } from "react-icons/hi";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa6";

const Home = () => {
  return (
    <div className="App overflow-x-hidden">
      <Hero />
      <section className="study-centre pt-20 md:mx-10 mx-5 md:mb-10 text-left">
        <div className="h-[400px] w-full md:flex gap-10">
          <div className="flex-1">
            <div className="flex items-center my-3 gap-3 mb-4 bg-green-600 w-fit px-5 py-2 rounded-full">
              <p className="text-white  font-semibold text-xs">
                मिझुहो इंडिया जापान स्टडी सेंटर
              </p>
            </div>

            <div>
              <h2 className="md:text-4xl font-bold leading-tight">
                Mizuho India Japan <br />
                <span className="text-green-600">Study Centre</span>
              </h2>

              <p className="my-5">
                Nurturing the next generation of change makers to create a
                win-win culture and strengthen the industry-academia ecosystem,
                benefiting both Indian and Japanese businesses.
              </p>

              <div className="flex w-full pt-5 mt-5 gap-10">
                <Link to="/mijsc-programs">
                  <button className="md:py-3 py-3 font-semibold md:px-10 px-2 bg-green-600 text-white md:w-48 rounded-md text-xs">
                    Explore Programs
                  </button>
                </Link>
                <Link to="/about-mijsc">
                  <button className="bg-white md:py-3 py-2 px-7 font-semibold md:px-10 bg-transparent border-2 md:w-48 rounded-md border-slate-400 text-xs">
                    Learn More
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <div className="flex-1  rounded-xl flex gap-2 relative">
            <div
              className="flex-1 h-full w-full rounded-3xl bg-cover"
              style={{
                backgroundPosition: "top",
                backgroundImage: `url(${process.env.PUBLIC_URL}/assets/students-collaborating.jpg)`,
              }}
            >
              {" "}
            </div>
            <div
              className="flex-1 bg-green-900 h-full w-full rounded-3xl bg-cover"
              style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/assets/imgs/about-iimb.jpg)`,
              }}
            >
              {" "}
            </div>
          </div>
        </div>
      </section>

      <section
        className="md:mx-10 mx-5 md:pt-24 pb-10"
        aria-label="About MIJSC"
      >
        <div className="flex flex-col md:flex-row md:gap-10 text-left">
          {/* LEFT: image + floating card */}
          <div
            className="relative flex-[0_0_48%] min-w-[280px]"
            aria-hidden="false"
          >
            {/* Main Image */}
            <figure
              className="w-full block rounded-[30px] overflow-hidden shadow-[0_30px_60px_rgba(15,23,36,0.15),_inset_0_1px_0_rgba(255,255,255,0.02)] border border-black/5 md:h-full h-[300px]"
              role="img"
              aria-label="Lecture hall at MIJSC"
            >
              <img
                src="/assets/abt-mijsc.jpg"
                alt="MIJSC classroom and students"
                className="w-full h-full object-cover"
              />
            </figure>
          </div>

          {/* RIGHT: text area */}
          <div className="flex-[0_0_50%] min-w-[260px] mt-10 md:mt-0 md:pr-5">
            <div className="inline-block bg-[#e6f6ef] text-[#0a6b3f] px-3 py-1 rounded-full text-[13px] font-semibold mb-5 tracking-wide">
              MIJSC AT IIMB
            </div>

            <h2
              className="font-semibold text-[#0b2030] mb-5"
              style={{
                fontSize: "clamp(22px, 3.6vw, 34px)",
              }}
            >
              About MIJSC
            </h2>

            <p className="text-gray-600 text-[16px] mb-4">
              The Mizuho India Japan Study Centre at the Indian Institute of
              Management Bangalore is dedicated to fostering excellence in
              education and research.
            </p>

            <p className="text-gray-600 text-[16px] mb-4">
              We focus on{" "}
              <strong className="text-gray-900 font-bold">
                conducting research
              </strong>{" "}
              and{" "}
              <strong className="text-gray-900 font-bold">
                imparting top-tier knowledge
              </strong>
              that strengthens the bonds between Indian and Japanese businesses.
            </p>

            <p className="text-gray-600 text-[16px] mb-4">
              Through our programs, we aim to create professionals who
              understand and appreciate both cultures, driving innovation and
              collaboration across borders.
            </p>

            <Link
              to="/about-mijsc"
              className="inline-flex items-center gap-2 mt-3 font-bold text-green-600 hover:text-green-800"
              aria-label="Read more about us"
            >
              Read more about us →
            </Link>
          </div>
        </div>
      </section>

      <Imgbanner />
      <ProgramCard />
      <section className="up-coming-events md:mx-10 mx-5 mb-10">
        <div className="my-5 flex justify-between">
          <div className="my-5 text-left">
            <h2 className="md:text-4xl text-xl font-bold">Upcoming Events</h2>
            <p className="pb-5 mb-5 mt-2 md:text-base text-xs ">
              Join us for our upcoming programs and workshops
            </p>
          </div>
          <div className="my-5 text-right">
            <div class="flex justify-center items-center gap-3 mb-4 pt-6">
              <Link to="/upcoming-events">
                <p class="text-green-600 font-bold md:text-base text-xs">
                  View More Events{" "}
                </p>
              </Link>
              <FaArrowRight className="mt-1 text-green-600" />
            </div>
          </div>
        </div>

        <div className="w-full h-fit md:flex gap-6 mt-10">
          <div className="mt-4 md:mt-0 shadow-sm md:w-[50%] w-[100%] pb-2 pt-5 flex bg-green-50 rounded-lg border border-green-200">
            <div className="w-fit h-fit pb-3 bg-white rounded-lg mx-4 shadow-2xl px-5">
              <p className="font-bold text-xs text-green-600 my-3"> Aug </p>
              <p className="font-bold text-3xl my-3"> 09 </p>
              <p className="text-slate-700 text-xs my-3"> 2026 </p>
            </div>
            <div className=" w-[22rem] h-fit pb-1 rounded-b-lg  text-left mx-3">
              <h3 className="text-2xl mb-4 font-bold">Graduation Ceremony</h3>
              <div className="w-full mt-2 justify-center gap-10">
                <div className="py-2 px-3 bg-[#05976a] text-white md:w-52 w-full rounded-full text-sm">
                  LMP Batch 4
                </div>
              </div>
              <div className="flex mb-4 gap-1 mt-3 items-center">
                <GrLocation className="text-green-600" />
                <p className="text-slate-700 text-sm">
                  Graduation Ceremony at IIMB
                </p>
              </div>
              <div className="flex gap-1 items-center mb-4">
                <MdOutlineCalendarToday className="text-green-600" />
                <p className="text-slate-700 text-sm">August 09, 2026</p>
              </div>
            </div>
          </div>
          <div className="mt-4 md:mt-0 shadow-sm md:w-[50%] w-[100%] pb-2 pt-5 flex bg-green-50 rounded-lg border border-green-200">
            <div className="w-fit h-fit pb-3 bg-white rounded-lg mx-4 shadow-2xl px-5">
              <p className="font-bold text-xs pt-2 text-green-600 my-3">
                {" "}
                Aug{" "}
              </p>
              <p className="font-bold text-3xl my-3"> 7-9 </p>
              <p className="text-slate-700 text-xs my-3 "> 2026 </p>
            </div>
            <div className=" w-[22rem] h-fit pb-1 rounded-b-lg  text-left mx-3">
              <h3 className="text-2xl mb-4 font-bold">LMP Conclave </h3>
              <div className="w-full mt-2 justify-center gap-10">
                <div className="px-3 bg-[#05976a] text-white py-2 md:w-44 w-full rounded-full text-xs">
                  LMP Batch 5
                </div>
              </div>
              <div className="flex mb-4 gap-1 mt-3 items-center">
                <GrLocation className="text-green-600" />
                <p className="text-slate-700 text-sm">LMP Conclave at IIMB</p>
              </div>
              <div className="flex gap-1 items-center mb-4">
                <MdOutlineCalendarToday className="text-green-600" />
                <p className="text-slate-700 text-sm ">August 7,8,9, 2026 </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Gallery />
    </div>
  );
};

export default Home;
